module.exports = __webpack_public_path__ + "img/ireland.efad590a.svg";